export function writeOops(text = 'Ooops. Something went wrong. Please reload the page.') {
  const span = document.createElement('span');
  span.textContent = text;
  document.body.appendChild(span);
}
